import { HttpStatusCode } from "axios";
import IClient from "../models/client/IClient";
import networkService from "./NetworkService";

class ClientService {

    /**
     * @description Gets all clients
     */
    async getClients(): Promise<IClient[]> {
        const result = await networkService.get<IClient[]>("/clients");

        if (!result.isSuccessful) {
            throw result.data;
        }

        if (result.status === HttpStatusCode.NoContent) {
            return [];
        }

        return result.data as IClient[];
    }

    /**
     * @description Gets the specified client
     * @param {string} arg The ID or slug of the client to be returned
     */
    async getClient(arg: string): Promise<IClient> {
        const result = await networkService.get<IClient>(`/client/${arg}`);

        if (result.isSuccessful) {
            return result.data as IClient;
        }

        throw result.data;
    }

    /**
     * @description Creates a new case study
     * @param {IClient} client The client data to be created
     */
    async createClient(client: IClient): Promise<string> {
        const result = await networkService.put<IClient, string>(`/client`, client);

        if (result.isSuccessful) {
            return result.data as string;
        }

        throw result.data;
    }

    /**
     * @description Partially updates the specified case study
     * @param {IClient} client The partial case study data to be updated
     */
    async updateClient(client: IClient): Promise<IClient> {
        const result = await networkService.patch<IClient, IClient>(`/client`, client);

        if (result.isSuccessful) {
            return result.data as IClient;
        }

        throw result.data;
    }

    /**
     * @description Deletes the specified case study
     * @param {string} id The ID of the case study to be deleted
     */
    async deleteClient(id: string): Promise<boolean> {
        const result = await networkService.delete<void>(`/client/${id}`);
        
        return result.isSuccessful;
    }
}

const clientService = new ClientService();
export default clientService;